import React from 'react';
import PrimaryLink from 'plaid-threads/PrimaryLink';
import Link from 'next/link';

import styles from './ReferenceLink.module.scss';

interface Props {
  icon: React.ReactNode;
  text: string;
  link?: string;
  linkText?: string;
}

const ReferenceLink: React.FC<Props> = (props: Props) => (
  <div className={styles.referenceLink}>
    {props.icon}
    <p className={styles.text}>{props.text}</p>
    {props.link && props.linkText && (
      <Link href={props.link} legacyBehavior passHref>
        <PrimaryLink>{props.linkText}</PrimaryLink>
      </Link>
    )}
  </div>
);

ReferenceLink.displayName = 'ReferenceLink';

export default ReferenceLink;
